import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { ControlType, SearchControl } from 'bpt-ui-library/bpt-search';
import { Observable, catchError, forkJoin, of, finalize, map } from 'rxjs';
import { DocumentLibraryConstants } from '../../document/document-library-constants';
import { DocumentSearch } from '../../document/models/documentSearch';
import { DocumentSearchResult } from '../../document/models/documentSearchResult';
import { DocumentMasterDataService } from '../../document/services/document-master-data.service';
import { EqmsScopeManagementService } from '../../shared/services/eqms-scope-management.service';
import { DocumentService } from '../../document/services/document.service';
import { DocumentsPanelListComponent } from '../documents-panel-list/documents-panel-list.component';
import { MessageService } from 'primeng/api';
import { DocumentSearchService } from '../../../app/shared/services/document-search.service';
import { SharedConstants } from '../../../app/shared/constants/shared-constants';
import { IEQMSScopeLookUpDetails } from '../../../app/shared/models/scopes/eqms-Scope-lookup-details';
import { AssignmentGroupsRequest } from '../../document/models/assignment-groups-request';
import { TrainingItemGroupService } from '../../training-item/services/training-item-group.service';
import { TrainingItemGroupSearchCriteria } from '../../training-item-group-search/models/training-item-group-search-criteria';
import { PanelHubConfiguration } from '../../shared-components/panel-hub/models/panel-hub-configuration';
import { PanelHubConstants } from '../../shared-components/panel-hub/constants/panel-hub-constants';
import { Features } from '../../shared-components/panel-hub/enums/features.enum';
import { PaginationConfigByFeature } from '../../shared-components/panel-hub/constants/feature-pagination-configuration';
import { DocumentQueryResult } from '../../document/models/document-query-result';
import { PaginationState } from '../../shared-components/panel-hub/models/pagination-state';
import { AppliedFilters } from '../../shared-components/panel-hub/models/applied-filters';
import { SortCriteria } from '../../shared-components/panel-hub/models/sort-criteria';
import { PanelHubStateChangedEvent } from '../../shared-components/panel-hub/models/panel-hub-state-changed-event';
import { PanelHubEventType } from '../../shared-components/panel-hub/enums/panel-hub-eventtype';
import { PanelEventHub } from '../../shared-components/panel-hub/models/panel-event-hub';
import { FilterConfig } from '../../shared-components/panel-hub/models/filter-config';
import { FilterCriteria } from '../../shared-components/panel-hub/models/filter-criteria';
import { SortField } from '../../shared-components/panel-hub/models/sort-field';
import { PanelView } from '../../shared-components/panel-hub/enums/panel-view.enum';
import { PanelHubComponent } from '../../shared-components/panel-hub/panel-hub.component';
import { SearchMapperService } from '../../shared/services/search-mapper.service';
import { PhaseValueConstants } from '../../shared/constants/phaseValues-constants';
import { DocumentReadAudit } from '../../document/models/document-read-audit';

@Component({
  selector: 'app-document-library-search',
  templateUrl: './document-library-search.component.html',
  styleUrls: ['./document-library-search.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class DocumentLibrarySearchComponent implements OnInit, AfterViewInit {
  @Input() feature: string = DocumentLibraryConstants.Document_Feature;
  @Input() panelListScreen!: string;
  @Output() emitSelectedData = new EventEmitter();
  @Output() shouldAddLinkItemsButtonDisplayed = new EventEmitter();
  @Output() shouldAddTrainingItemAsDocumentButtonDisplayed = new EventEmitter();
  @Input() enableToaster: boolean = false;

  documentSearchResult: DocumentSearchResult[] = [];
  panelListType = DocumentLibraryConstants.DocLibrary_PanelListType;
  isSearch = false;
  documentLookUpData: any;
  placeHolder: string = DocumentLibraryConstants.DocumentSearch_Place_Holder_Text;
  errorText: string = '';
  filterData: any[] = [];
  documentMasterData: any = {};
  scopeList: any = [];
  sbuList: any = [];
  phaseList: any = [];
  typeAndLocalTypeList: any = [];
  isMasterDataLoaded = false;
  categoryAndLocalCategoryList: any = [];
  spinnerOn: boolean = false;
  exportButtonAvailable: boolean = true;
  documentSearchData: DocumentSearch = new DocumentSearch;
  dataSource: string = SharedConstants.Document_Library_Panel_List_Data_Source;
  userList: any = [];
  masterFilterData: any = {};
  displayDataCollected: any;

  // PDF preview modal properties
  readOnlyFileUrl: string = '';
  openPdfPreviewModal: boolean = false;

  // Pagination-related properties
  panelEventHub!: PanelEventHub;
  panelHubConfig: PanelHubConfiguration = {
    title: "",
    feature: Features.DocumentLibraryView,
    standardFilterCount: PanelHubConstants.StandardFilterLength,
    showSelectAll: true,
    enableShowAllToggle: false,
    enableSelectAll: true,
    enableSelection: true,
    selectionIdField: 'documentIdentifier',
    enableToggling: true,
    enablePanelCardClick: false,
    enablePanelHighLight: false,
    enablePanelCardView: false,
    enableExport: true,
    enableExpandCollapse: true,
    enableViewModes: true,
    enableAssignmentView: true,
    enableWhereAmIUsedView: true,
    paginationConfig: PaginationConfigByFeature[Features.DocumentLibraryView]
  };
  pagedData: DocumentQueryResult = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
  currentFilters: AppliedFilters | null = null;
  currentPagination: PaginationState | null = null;
  currentSort: SortCriteria | null = null;
  isPanelHubDataAvailable: boolean = false;
  noData: boolean = false;
  currentView: PanelView = PanelView.Default;
  // Flag to track if user has initiated a search
  hasUserSearched: boolean = false;
  // Base filters from main search (bpt-search) - preserved across view changes and filter resets
  baseFilters: AppliedFilters | null = null;

  // Primary search text from bpt-search component (goes to filter.searchText)
  primarySearchText: string | null = null;
  // Secondary search text from panel-hub (min 3 chars, goes to secondarySearchText)
  secondarySearchText: string | null = null;

  // Panel filter for eQMS Scope (multi-value field requiring AND logic with main search)
  panelEQMSScope: string[] | null = null;

  // Selection state tracking for bulk user replacement (from panel-hub)
  selectAllActive: boolean = false;
  selectedDocumentIds: Set<string> = new Set();
  deselectedDocumentIds: Set<string> = new Set();

  searchControl: SearchControl[] = [
    {
      controlType: ControlType.Datepicker,
      label: 'Effective Date Range',
      fieldName: 'effectiveDateRange',
      enableRange: true,
      value: [],
      order: 8,
    },
    {
      controlType: ControlType.Datepicker,
      label: 'Next Review Date Range',
      fieldName: 'periodicReviewDateRange',
      enableRange: true,
      value: [],
      order: 9,
    },
    {
      controlType: ControlType.Datepicker,
      label: 'Creation Date Range',
      fieldName: 'creationDateRange',
      enableRange: true,
      value: [],
      order: 11,
    },
  ];

  @ViewChild(DocumentsPanelListComponent)
  private childDocPanel!: DocumentsPanelListComponent;

  @ViewChild(PanelHubComponent)
  private panelHub!: PanelHubComponent;

  constructor(
    private documentMasterDataService: DocumentMasterDataService,
    private messageService: MessageService,
    private eqmsScopeManagementService: EqmsScopeManagementService,
    private documentService: DocumentService,
    private documentSearchService: DocumentSearchService,
    private trainingItemGroupService: TrainingItemGroupService,
    private searchMapperService: SearchMapperService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initialize();
  }

  ngAfterViewInit() { }

  initialize() {
    this.spinnerOn = true;

    forkJoin({
      masterData: this.documentMasterDataService.getDocumentMasterData(),
      scopeList: this.documentMasterDataService.geteQMSScopesForDocumentSearch(this.feature),
      subBUData: this.documentMasterDataService.getsubBuMasterData(),
      usersData: this.documentMasterDataService.getUsersMasterData()
    }).subscribe({
      next: ({ masterData, scopeList, subBUData, usersData }) => {
        this.documentMasterData = masterData;
        this.populateEQMSScopeList(scopeList);
        this.populatesubBuList(subBUData);
        this.populateUsersList(usersData);
        this.loadDocumentSearchFilterOptions();

        const scopeIds = scopeList.map((scope: IEQMSScopeLookUpDetails) => scope.eQMSScopeId.toString());
        const scopeIdsAsNumbers = scopeList.map((scope: IEQMSScopeLookUpDetails) => scope.eQMSScopeId);
        const assignmentTypes = [
          DocumentLibraryConstants.Assignment_types.AssignedAdmins,
          DocumentLibraryConstants.Assignment_types.AssignedDocControl,
          DocumentLibraryConstants.Assignment_types.AssignedQA
        ];
        const assignmentGroupsRequest = new AssignmentGroupsRequest(scopeIds, assignmentTypes);
        const trainingItemGroupSearchCriteria: TrainingItemGroupSearchCriteria = { eQMSScopes: scopeIdsAsNumbers };

        forkJoin({
          assignmentGroups: this.documentService.getAssignmentGroups(assignmentGroupsRequest).pipe(catchError(() => of([]))),
          trainingItemGroups: this.trainingItemGroupService.searchTrainingItemGroups(trainingItemGroupSearchCriteria).pipe(catchError(() => of({ records: [] })))
        }).subscribe({
          next: ({ assignmentGroups, trainingItemGroups }) => {
            const assignmentGroupsArray = Array.isArray(assignmentGroups) ? assignmentGroups : [];
            const trainingItemGroupRecords = trainingItemGroups?.records || [];
            this.populateMasterFilterData(scopeList, subBUData, usersData, assignmentGroupsArray, trainingItemGroupRecords);
            this.initializePanelHub();
            this.isMasterDataLoaded = true;
          },
          error: () => {
            this.populateMasterFilterData(scopeList, subBUData, usersData, [], []);
            this.initializePanelHub();
            this.isMasterDataLoaded = true;
          }
        });
      },
      error: (error: any) => {
        console.error('Error while fetching data:', error);
        this.spinnerOn = false;
      },
    });
  }

  // Panel Hub Methods
  onPanelEventHubInitialized(event: PanelEventHub) {
    this.panelEventHub = event;
  }

  onPanelHubStateChanged = (event: PanelHubStateChangedEvent) => {
    // Only process panel-hub events if user has initiated a search
    if (!this.hasUserSearched) return;
    
    switch (event.type) {
      case PanelHubEventType.FilterChanged:
        const panelHubFilters = event.state.filters || null;
        // Extract secondary search text from panel-hub filters
        this.secondarySearchText = panelHubFilters?.searchText || null;
        
        // Clear panelEQMSScope if no filters (filters cleared)
        if (!panelHubFilters || !panelHubFilters.filters || panelHubFilters.filters.length === 0) {
          this.panelEQMSScope = null;
        }
        
        // Merge base filters from main search with panel-hub filters
        const mergeResult = this.mergeFilters(this.baseFilters, panelHubFilters);
        
        // Check if impossible condition detected
        if (mergeResult === 'IMPOSSIBLE') {
          this.handleImpossibleFilterCondition();
          return;
        }
        
        this.currentFilters = mergeResult;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.clearSelections();
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.SortChanged:
        this.currentSort = event.state.sort || null;
        if (this.currentPagination) this.currentPagination.pageNumber = 1;
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.PaginationChanged:
        this.currentPagination = event.state.pagination || null;
        this.refreshPanelHubData();
        break;
      case PanelHubEventType.SelectAllToggled:
      case PanelHubEventType.ItemSelectionChanged:
        this.handleSelectionChange(event);
        break;
    }
  }

  /**
   * Merges base filters from main search with panel-hub filters.
   * For single-value fields (Phase, Type, etc.), values are intersected (AND logic).
   * For EQMSScope (multi-value field), values are extracted separately for backend AND logic.
   * Returns 'IMPOSSIBLE' if any single-value field has empty intersection.
   */
  private mergeFilters(baseFilters: AppliedFilters | null, panelHubFilters: AppliedFilters | null): AppliedFilters | null | 'IMPOSSIBLE' {
    if (!baseFilters && !panelHubFilters) return null;
    if (!baseFilters) return panelHubFilters;
    if (!panelHubFilters) return { ...baseFilters };

    // Start with base filters
    const mergedFilterMap = new Map<string, FilterCriteria>();
    let hasImpossibleCondition = false;
    let panelHasEQMSScope = false;
    
    // Add base filters
    if (baseFilters.filters) {
      baseFilters.filters.forEach(filter => {
        mergedFilterMap.set(filter.field, { ...filter, values: [...filter.values] });
      });
    }
    
    // Merge with panel-hub filters
    if (panelHubFilters.filters) {
      panelHubFilters.filters.forEach(filter => {
        const existingFilter = mergedFilterMap.get(filter.field);
        
        if (filter.field === 'EQMSScope') {
          // Special handling for EQMSScope - extract panel values separately for backend AND logic
          // Whether or not main search has EQMSScope, store panel values to send separately
          this.panelEQMSScope = filter.values.map(v => String(v));
          panelHasEQMSScope = true;
          return; // Don't add to merged filters, handled separately via PanelEQMSScope parameter
        }
        
        if (existingFilter) {
          const baseSet = new Set(existingFilter.values.map(v => String(v)));
          const panelSet = new Set(filter.values.map(v => String(v)));
          const intersection = Array.from(baseSet).filter(v => panelSet.has(v));
          
          if (intersection.length === 0) {
            // Empty intersection = impossible condition
            hasImpossibleCondition = true;
          }
          existingFilter.values = intersection;
        } else {
          // Field doesn't exist in base filters, add panel hub filter as-is
          mergedFilterMap.set(filter.field, { ...filter, values: [...filter.values] });
        }
      });
    }
    
    // If panel doesn't have EQMSScope filter, clear it
    if (!panelHasEQMSScope) {
      this.panelEQMSScope = null;
    }

    // If impossible condition detected, return special marker
    if (hasImpossibleCondition) {
      return 'IMPOSSIBLE';
    }

    return {
      filters: Array.from(mergedFilterMap.values()),
      searchText: panelHubFilters.searchText || undefined
    };
  }

  private handleSelectionChange(event: PanelHubStateChangedEvent) {
    const selectedItemIds = event.state.selectedItems || [];
    const deselectedItemIds = event.state.deselectedItems || [];
    const isSelectAllActive = event.state.isSelectAllAcrossPages || false;

    // Update selection state for bulk replacement - no need to emit, template checks selectedDocumentIds.size directly
    this.selectAllActive = isSelectAllActive;
    this.selectedDocumentIds = new Set(selectedItemIds);
    this.deselectedDocumentIds = new Set(deselectedItemIds);

    // Emit the actual selected DocumentSearchResult objects for components that use this library search
    this.emitSelectedDocuments();
  }

  /**
   * Handles the case when panel filters result in impossible conditions (empty intersection).
   * Sets empty results immediately without making a backend call.
   */
  private handleImpossibleFilterCondition(): void {
    // Set empty results
    this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
    this.documentSearchResult = [];
    this.noData = true;
    this.isPanelHubDataAvailable = true;
    
    // Update pagination
    if (this.currentPagination) {
      this.currentPagination.totalRecords = 0;
    }
    
    // Stop any ongoing loading
    this.panelEventHub?.stopLoader();
    this.spinnerOn = false;
    
    // Clear selections
    this.clearSelections();
    
    // Optionally show a message to user
    if (this.enableToaster) {
      this.messageService.add({
        severity: 'info',
        summary: 'No matching documents',
        detail: 'The selected filters do not match any documents from your search results.',
        life: 3000
      });
    }
  }

  private emitSelectedDocuments(): void {
    const selectedDocuments: DocumentSearchResult[] = [];


    if (this.pagedData?.data && Array.isArray(this.pagedData.data)) {
      this.pagedData.data.forEach((doc: DocumentSearchResult) => {
        const docId = (doc as any)['documentIdentifier'];
        
        if (this.selectAllActive && !this.deselectedDocumentIds.has(docId)) {    
            selectedDocuments.push(doc);         
        } else if (this.selectedDocumentIds.has(docId)) {
            selectedDocuments.push(doc);
          }
      });
    }

    // Emit the selected documents
    this.displayDataCollected = selectedDocuments;
    this.emitSelectedData.emit(selectedDocuments);
  }

  private clearSelections(): void {
    // Clear all selection states
    this.selectAllActive = false;
    this.selectedDocumentIds = new Set();
    this.deselectedDocumentIds = new Set();
    
    // Clear selection in the panel list component
    this.childDocPanel?.clearSelection();
    
    // Emit empty selection
    this.displayDataCollected = [];
    this.emitSelectedData.emit([]);
  }

  onViewChanged(view: PanelView) {
    this.currentView = view;
    // Force change detection for projected templates
    this.cdr.detectChanges();
    // Update filter and sort configurations based on the new view
    const filterConfigs = this.getFilterConfigsForView(view);
    const sortOptions = this.getSortOptionsForView(view);
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
    // Reset filters and pagination when view changes
    this.resetPanelConfiguration();
    this.refreshPanelHubData();
  }

  public clearSelectionsAfterBulkOperation(): void {
    // Clear all selections after bulk user replacement or other operations
    this.panelHub.clearSelection();
  }

  private getFilterConfigsForView(view: PanelView): FilterConfig[] {
    switch (view) {
      case PanelView.Assignment:
        return this.buildFilterConfigsForAssignmentView();
      case PanelView.WhereAmIUsed:
        return this.buildFilterConfigsForWhereAmIUsedView();
      case PanelView.Default:
      default:
        return this.buildFilterConfigs();
    }
  }

  private getSortOptionsForView(view: PanelView): SortField[] {
    switch (view) {
      case PanelView.Assignment:
        return this.buildSortOptionsForAssignmentView();
      case PanelView.WhereAmIUsed:
        return this.buildSortOptionsForWhereAmIUsedView();
      case PanelView.Default:
      default:
        return this.buildSortOptions();
    }
  }

  /**
   * Updates panelHubConfig with filter and sort configs for the current view.
   * Called when performing a new main search to preserve the view-specific configurations.
   */
  private updatePanelHubConfigForCurrentView() {
    const filterConfigs = this.getFilterConfigsForView(this.currentView);
    const sortOptions = this.getSortOptionsForView(this.currentView);
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
  }

  private initializePanelHub() {
    const filterConfigs = this.buildFilterConfigs();
    const sortOptions = this.buildSortOptions();
    this.setPanelHubConfigExtensions(filterConfigs, sortOptions);
    this.spinnerOn = false;
  }

  private buildFilterConfigs(): FilterConfig[] {
    return [
      { displayName: 'Phase', fieldName: 'Phase', options: this.masterFilterData?.phases || [] },
      { displayName: 'Type', fieldName: 'DocumentType', options: this.masterFilterData?.documentTypes || [] },
      { displayName: 'Category', fieldName: 'Category', options: this.masterFilterData?.categories || [] },
      { displayName: 'Local Type', fieldName: 'LocalType', options: this.masterFilterData?.localTypes || [] },
      { displayName: 'Local Category', fieldName: 'LocalCategory', options: this.masterFilterData?.localCategories || [] },
      { displayName: 'Sub-BU', fieldName: 'ResponsibleSubBU', options: this.masterFilterData?.subBUList || [] },
      { displayName: 'eQMS Scope', fieldName: 'EQMSScope', options: this.masterFilterData?.eqmsScopeList || [] },
      { displayName: 'Assigned Admin(s)', fieldName: 'AssignedAdmins', options: this.masterFilterData?.assignedAdminsList || [] },
    ].filter(fc => fc.options && fc.options.length > 0);
  }

  private buildSortOptions(): SortField[] {
    return [
      { fieldDisplayName: 'Title', fieldName: 'Title' },
      { fieldDisplayName: 'Phase', fieldName: 'Phase' },
      { fieldDisplayName: 'Type', fieldName: 'DocumentType' },
      { fieldDisplayName: 'Category', fieldName: 'Category' },
      { fieldDisplayName: 'Local Category', fieldName: 'LocalCategory' },
      { fieldDisplayName: 'Local Type', fieldName: 'LocalType' },
      { fieldDisplayName: 'Sub-BU', fieldName: 'ResponsibleSubBU' },
      { fieldDisplayName: 'eQMS Scope', fieldName: 'EQMSScope' },
      { fieldDisplayName: 'Assigned Admin(s)', fieldName: 'AssignedAdmins' },
      { fieldDisplayName: 'Effective Date', fieldName: 'EffectiveDate' },
      { fieldDisplayName: 'Requested Effective Date', fieldName: 'RequestedEffectiveDate' },
      { fieldDisplayName: 'Next Review Date', fieldName: 'PeriodicReviewDate' },
    ];
  }

  private buildFilterConfigsForAssignmentView(): FilterConfig[] {
    return [
      { displayName: 'Phase', fieldName: 'Phase', options: this.masterFilterData?.phases || [] },
      { displayName: 'Author', fieldName: 'Author', options: this.masterFilterData?.usersList || [] },
      { displayName: 'Assigned Admin(s)', fieldName: 'AssignedAdmins', options: this.masterFilterData?.assignedAdminsList || [] },
      { displayName: 'Collaborator(s)', fieldName: 'Collaborators', options: this.masterFilterData?.usersList || [] },
      { displayName: 'Assigned QA(s)', fieldName: 'AssignedQas', options: this.masterFilterData?.assignedQAsList || [] },
      { displayName: 'Assigned Doc Control(s)', fieldName: 'AssignedDocControl', options: this.masterFilterData?.assignedDocControlsList || [] },
      { displayName: 'Reviewer(s)', fieldName: 'Reviewers', options: this.masterFilterData?.usersList || [] },
      { displayName: 'Approver(s)', fieldName: 'Approvers', options: this.masterFilterData?.usersList || [] },
      { displayName: 'Periodic Reviewer(s)', fieldName: 'PeriodicReviewers', options: this.masterFilterData?.usersList || [] },
      { displayName: 'Internal Client Contact(s)', fieldName: 'InternalClientContacts', options: this.masterFilterData?.usersList || [] },
    ].filter(fc => fc.options && fc.options.length > 0);
  }

  private buildSortOptionsForAssignmentView(): SortField[] {
    return [
      { fieldDisplayName: 'Phase', fieldName: 'Phase' },
      { fieldDisplayName: 'Author', fieldName: 'Author' },
      { fieldDisplayName: 'Assigned Admin(s)', fieldName: 'AssignedAdmins' },
      { fieldDisplayName: 'Collaborator(s)', fieldName: 'Collaborators' },
      { fieldDisplayName: 'Assigned QA(s)', fieldName: 'AssignedQas' },
      { fieldDisplayName: 'Assigned Doc Control(s)', fieldName: 'AssignedDocControl' },
      { fieldDisplayName: 'Reviewer(s)', fieldName: 'Reviewers' },
      { fieldDisplayName: 'Approver(s)', fieldName: 'Approvers' },
      { fieldDisplayName: 'Periodic Reviewer(s)', fieldName: 'PeriodicReviewers' },
      { fieldDisplayName: 'Internal Client Contact(s)', fieldName: 'InternalClientContacts' },
    ];
  }

  private buildFilterConfigsForWhereAmIUsedView(): FilterConfig[] {
    return [
      { displayName: 'eQMS Scope(s)', fieldName: 'EQMSScope', options: this.masterFilterData?.eqmsScopeList || [] },
      { displayName: 'Curriculum(s)', fieldName: 'Curriculums', options: this.masterFilterData?.curriculumsList || [] },
      { displayName: 'Training Item Group(s)', fieldName: 'TrainingItemGroups', options: this.masterFilterData?.trainingItemGroupsList || [] },
    ].filter(fc => fc.options && fc.options.length > 0);
  }

  private buildSortOptionsForWhereAmIUsedView(): SortField[] {
        return [
      { fieldDisplayName: 'eQMS Scope(s)', fieldName: 'EQMSScope' },
      { fieldDisplayName: 'Curriculum(s)', fieldName: 'Curriculums' },
      { fieldDisplayName: 'Training Item Group(s)', fieldName: 'trainingItemGroupNames' },
    ];
  }

  private setPanelHubConfigExtensions(filterConfigs: FilterConfig[], sortOptions: SortField[]) {
    this.panelHubConfig = { ...this.panelHubConfig, filterConfigs, sortOptions };
  }

  private fetchInitialPagedDocuments() {
    const paginationState: PaginationState = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };

    this.documentService.queryDocumentLibraryData(
      paginationState,
      null,
      null,
      this.primarySearchText,
      this.secondarySearchText,
      this.documentSearchData.users,
      this.panelEQMSScope
    ).pipe(
      map(result => ({ result })),
      catchError(err => {
        this.handleInitError();
        return of(null);
      }),
      finalize(() => {
        this.spinnerOn = false;
      })
    ).subscribe(res => {
      if (!res) return;
      this.applyPagedResult(res.result);
      this.isPanelHubDataAvailable = true;
      this.isSearch = true;
      this.setButtonOnSearchRecordCount(res.result.totalRecords);
    });
  }

  private refreshPanelHubData() {
    if (!this.currentPagination) {
      this.currentPagination = {
        pageNumber: this.panelHubConfig.paginationConfig.startPage,
        pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
        totalRecords: 0
      };
    }
    this.fetchPagedDocumentData();
  }

  private fetchPagedDocumentData() {
    if (!this.currentPagination) return;
    this.panelEventHub?.startLoader();

    this.documentService.queryDocumentLibraryData(
      this.currentPagination,
      this.currentFilters,
      this.currentSort,
      this.primarySearchText,
      this.secondarySearchText,
      this.documentSearchData.users,
      this.panelEQMSScope
    ).pipe(
      map(result => ({ result })),
      catchError(err => {
        this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
        this.noData = true;
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Err,
          summary: DocumentLibraryConstants.DocumentSearch_Error_Message,
          sticky: true
        });
        return of(null);
      }),
      finalize(() => {
        this.panelEventHub?.stopLoader();
        this.spinnerOn = false;
      })
    ).subscribe(res => {
      if (!res) return;
      this.applyQueryResult(res.result);
      this.isPanelHubDataAvailable = true;
      this.isSearch = true;
      this.setButtonOnSearchRecordCount(res.result.totalRecords);
    });
  }

  private applyPagedResult(result: DocumentQueryResult) {
    const processed = this.transformDocuments(result.data);
    this.pagedData = {
      totalRecords: result.totalRecords,
      data: processed,
      pageNumber: result.pageNumber ?? 1,
      pageSize: result.pageSize ?? 0
    };
    this.documentSearchResult = processed;
    this.noData = processed.length === 0;
    this.currentPagination = this.initPagination(result.totalRecords);
  }

  private applyQueryResult(result: DocumentQueryResult) {
    const processed = this.transformDocuments(result.data);
    this.pagedData = {
      totalRecords: result.totalRecords,
      data: processed,
      pageNumber: result.pageNumber ?? 1,
      pageSize: result.pageSize ?? 0
    };
    this.documentSearchResult = processed;
    this.noData = processed.length === 0;
    if (this.currentPagination) this.currentPagination.totalRecords = result.totalRecords;
  }

  private transformDocuments(list: DocumentSearchResult[] | null | undefined): DocumentSearchResult[] {
    if (!Array.isArray(list) || list.length === 0) return [];
    return list.map(doc => this.enrichDocument(doc));
  }

  private enrichDocument(doc: DocumentSearchResult): DocumentSearchResult {
    // Map eQMSScope IDs to display names
    let eQMSScopeDisplayNames: string[] | undefined = undefined;
    if (doc.eQMSScope && Array.isArray(doc.eQMSScope) && this.scopeList.length > 0) {
      eQMSScopeDisplayNames = doc.eQMSScope
        .map(scopeId => {
          const scope = this.scopeList.find((s: any) => s.value === scopeId);
          return scope ? scope.name : null;
        })
        .filter((name: string | null): name is string => name !== null);
    }
    
    return {
      ...doc,
      eQMSScopeDisplayNames: eQMSScopeDisplayNames || doc.eQMSScopeDisplayNames
    };
  }

  private initPagination(totalRecords: number): PaginationState {
    return {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords
    };
  }

  private handleInitError() {
    this.isPanelHubDataAvailable = false;
    this.spinnerOn = false;
    this.pagedData = { totalRecords: 0, data: [], pageNumber: 1, pageSize: 0 };
    this.noData = true;
    this.messageService.add({
      severity: DocumentLibraryConstants.Severity_Err,
      summary: DocumentLibraryConstants.DocumentSearch_Error_Message,
      sticky: true
    });
  }

  resetPanelConfiguration = () => {
    this.currentPagination = {
      pageNumber: this.panelHubConfig.paginationConfig.startPage,
      pageSize: this.panelHubConfig.paginationConfig.defaultPageSize,
      totalRecords: 0
    };
    // Restore base filters from main search instead of clearing them
    this.currentFilters = this.baseFilters ? { ...this.baseFilters } : null;
    this.currentSort = null;
    this.secondarySearchText = null;
    this.panelEQMSScope = null; // Reset panel eQMS Scope filter
    if (this.panelEventHub) {
      this.panelEventHub.resetConfigurations();
    }
  }

  onExportClicked() {
    // Extract secondary search text from filters BEFORE mapping to prevent it from being mapped to Filter.SearchText
    const secondarySearchFromFilters = this.secondarySearchText || null;
    const filtersForMapping = this.currentFilters ? { ...this.currentFilters, searchText: undefined } : null;

    // Build the same base structure used for queryDocumentLibraryData
    const base = this.searchMapperService.mapToBaseSearchRequest(filtersForMapping, this.currentSort, this.currentPagination);
    base.Filter = base.Filter || { SearchText: null, FilterItems: [] };
    base.Filter.SearchText = this.primarySearchText || null;

    // Create the final export payload matching the document search structure
    const exportPayload = {
      ...base,
      SecondarySearchText: secondarySearchFromFilters || null,
      Users: this.documentSearchData.users || null,
      PanelEQMSScope: this.panelEQMSScope || null
    };

    this.documentSearchService.exportToExcel(exportPayload);
  }

  openDocument(documentNumber: string, version: string) {
    var url = location.origin.concat("/eqms.documentDetails/", documentNumber, ":", version);
    window.open(url, "_blank");
  }

  openCurriculum(curriculumScopeId: number) {
    var url = location.origin.concat(`/eqms.curriculum/curriculumLinkout?scopeId=${curriculumScopeId}&&isLinkout=true`);
    window.open(url, "_blank");
  }

  openTrainingItemGroup(trainingItemGroupNumber: string) {
    var url = location.origin.concat(`/eqms.training-item/trainingItemGroupLinkout?trainingItemGroupNumber=${trainingItemGroupNumber}&&isLinkout=true`);
    window.open(url, "_blank");
  }

  calculatePhaseColor(phase: string): string {
    let statusColor = '';
    switch (Number(phase)) {
      case 0:
        statusColor = 'collaboration';
        break;
      case 1:
        statusColor = 'q_a_review';
        break;
      case 2:
        statusColor = 'formatting';
        break;
      case 3:
        statusColor = 'in_review';
        break;
      case 4:
        statusColor = 'ready_for_approval';
        break;
      case 5:
        statusColor = 'approved';
        break;
      case 6:
        statusColor = 'effective';
        break;
      case 7:
        statusColor = 'archived';
        break;
      case 8:
        statusColor = 'cancelled';
        break;
      case 9:
        statusColor = 'obsolete';
        break;
      case 10:
        statusColor = 'client_signature';
        break;
    }
    return statusColor;
  }

  displayPhaseLabelWithDate(phase: string, effectiveDate: string, requestedEffectiveDate: string): string {
    let displayData = '';
    const phaseNum = Number(phase);
    switch (phaseNum) {
      case 0:
        displayData = 'Collaboration';
        break;
      case 1:
        displayData = requestedEffectiveDate ? `QA Review (${this.formatDate(requestedEffectiveDate)})` : 'QA Review';
        break;
      case 2:
        displayData = requestedEffectiveDate ? `Formatting (${this.formatDate(requestedEffectiveDate)})` : 'Formatting';
        break;
      case 3:
        displayData = requestedEffectiveDate ? `In Review (${this.formatDate(requestedEffectiveDate)})` : 'In Review';
        break;
      case 4:
        displayData = requestedEffectiveDate ? `Ready for Approval (${this.formatDate(requestedEffectiveDate)})` : 'Ready for Approval';
        break;
      case 5:
        displayData = effectiveDate ? `Approved (${this.formatDate(effectiveDate)})` : 'Approved';
        break;
      case 6:
        displayData = effectiveDate ? `Effective (${this.formatDate(effectiveDate)})` : 'Effective';
        break;
      case 7:
        displayData = effectiveDate ? `Archived (${this.formatDate(effectiveDate)})` : 'Archived';
        break;
      case 8:
        displayData = 'Cancelled';
        break;
      case 9:
        displayData = effectiveDate ? `Obsolete (${this.formatDate(effectiveDate)})` : 'Obsolete';
        break;
      case 10:
        displayData = requestedEffectiveDate ? `Client Signature (${this.formatDate(requestedEffectiveDate)})` : 'Client Signature';
        break;
      default:
        displayData = phase;
    }
    return displayData;
  }

  private formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const day = date.toLocaleDateString('en-GB', { day: '2-digit' });
    const month = date.toLocaleDateString('en-GB', { month: 'short' });
    const year = date.toLocaleDateString('en-GB', { year: 'numeric' });
    return `${day}-${month}-${year}`;
  }

  calculateToolTip(attributes: any[]): string {
    if (!attributes || attributes.length === 0) return '';
    return attributes.map(attr => attr.name).join(', ');
  }

  // Legacy search methods (kept for bpt-search component compatibility)
  getAdvancedSearchResults = (filters: Array<any>, searchText: string): Observable<number> => {
    this.filterData = filters;
    this.resetDocumentSearchData();
    // Set primary search text (goes to filter.searchText in payload)
    this.primarySearchText = (searchText !== null && searchText !== undefined) ? searchText : null;
    this.documentSearchData.searchText = this.primarySearchText ?? undefined;
    
    filters.forEach(filterControl => {
      switch (filterControl.columnName) {
        case "phase":
          this.documentSearchData.phases = filterControl.values
          break;
        case "type":
          this.documentSearchData.documentTypes = filterControl.values
          break;
        case "localType":
          this.documentSearchData.localTypes = filterControl.values
          break;
        case "category":
          this.documentSearchData.categories = filterControl.values
          break;
        case "localCategory":
          this.documentSearchData.localCategories = filterControl.values
          break;
        case "responsibleSubBU":
          this.documentSearchData.responsibleSubBUs = filterControl.values
          break;
        case "eQMSScope":
          this.documentSearchData.eQMSScopes = filterControl.values
          break;
        case "effectiveDateRange":
          this.documentSearchData.effectiveDates = this.convertDateFormat(filterControl.values)
          break;
        case "periodicReviewDateRange":
          this.documentSearchData.periodicReviewDates = this.convertDateFormat(filterControl.values)
          break;
        case "creationDateRange":
          this.documentSearchData.creationDates = this.convertDateFormat(filterControl.values)
          break;
        case "tags":
          this.documentSearchData.tags = filterControl.values
          break;
        case "user":
          this.documentSearchData.users = filterControl.values
          break;
      }
    });

    const isAllValuesNullOrUndefined = this.areAllValuesNullOrUndefined(this.documentSearchData);

    if (isAllValuesNullOrUndefined) {
      this.messageService.add({
        severity: DocumentLibraryConstants.Severity_Info,
        summary: `${DocumentLibraryConstants.DocumentSearchEmpty_Filters}`,
      });
      return of(0);
    }

    // Reset secondary search and pagination for fresh primary search
    this.secondarySearchText = null;
    this.documentSearchService.searchCriteria = {};
    this.documentSearchService.searchCriteria = this.documentSearchData;
    // Convert bpt-search filters to AppliedFilters format and store as base filters
    this.baseFilters = this.convertToAppliedFilters();
    // Ensure panelHubConfig has correct filter/sort configs for the current view
    this.updatePanelHubConfigForCurrentView();
    // Reset panel configuration (this will restore baseFilters)
    this.resetPanelConfiguration();
    // Mark that user has initiated a search
    this.hasUserSearched = true;
    // Show spinner for main search
    this.spinnerOn = true;
    this.refreshPanelHubData();

    return of(this.pagedData.totalRecords);
  };

  private areAllValuesNullOrUndefined(data: any): boolean {
    return Object.entries(data).every(([key, value]) => {
      if (key === DocumentLibraryConstants.Document_Search_Text) {
        return typeof value === 'string' && value.trim() === '';
      }
      if (key === DocumentLibraryConstants.Document_Search_Phase_Text) {
        return Array.isArray(value) && value.length === 0;
      }
      return value === undefined;
    });
  }

  /**
   * Converts documentSearchData (from bpt-search) to AppliedFilters format (for panel-hub/API)
   */
  private convertToAppliedFilters(): AppliedFilters {
    const filters: FilterCriteria[] = [];

    if (this.documentSearchData.phases && this.documentSearchData.phases.length > 0) {
      filters.push({ field: 'Phase', values: this.documentSearchData.phases });
    }
    if (this.documentSearchData.documentTypes && this.documentSearchData.documentTypes.length > 0) {
      filters.push({ field: 'DocumentType', values: this.documentSearchData.documentTypes });
    }
    if (this.documentSearchData.categories && this.documentSearchData.categories.length > 0) {
      filters.push({ field: 'Category', values: this.documentSearchData.categories });
    }
    if (this.documentSearchData.localTypes && this.documentSearchData.localTypes.length > 0) {
      filters.push({ field: 'LocalType', values: this.documentSearchData.localTypes });
    }
    if (this.documentSearchData.localCategories && this.documentSearchData.localCategories.length > 0) {
      filters.push({ field: 'LocalCategory', values: this.documentSearchData.localCategories });
    }
    if (this.documentSearchData.responsibleSubBUs && this.documentSearchData.responsibleSubBUs.length > 0) {
      filters.push({ field: 'ResponsibleSubBU', values: this.documentSearchData.responsibleSubBUs });
    }
    if (this.documentSearchData.eQMSScopes && this.documentSearchData.eQMSScopes.length > 0) {
      filters.push({ field: 'EQMSScope', values: this.documentSearchData.eQMSScopes });
    }
    if (this.documentSearchData.tags) {
      const tagsArray = Array.isArray(this.documentSearchData.tags) ? this.documentSearchData.tags : [this.documentSearchData.tags];
      if (tagsArray.length > 0) {
        filters.push({ field: 'Tags', values: tagsArray });
      }
    }
    if (this.documentSearchData.effectiveDates && this.documentSearchData.effectiveDates.length > 0) {
      filters.push({ field: 'EffectiveDate', values: this.documentSearchData.effectiveDates });
    }
    if (this.documentSearchData.periodicReviewDates && this.documentSearchData.periodicReviewDates.length > 0) {
      filters.push({ field: 'PeriodicReviewDate', values: this.documentSearchData.periodicReviewDates });
    }
    if (this.documentSearchData.creationDates && this.documentSearchData.creationDates.length > 0) {
      filters.push({ field: 'CreatedOn', values: this.documentSearchData.creationDates });
    }

    return {
      filters,
      searchText: this.primarySearchText || undefined
    };
  }

  getSearchResults = (searchText: string): Observable<number> => {
    this.resetDocumentSearchData();
    // Set primary search text (goes to filter.searchText in payload)
    this.primarySearchText = (searchText !== null && searchText !== undefined) ? searchText : null;
    this.documentSearchData.searchText = this.primarySearchText ?? undefined;
    this.filterData = [];

    // Reset secondary search and panel-hub filters for fresh primary search
    this.secondarySearchText = null;
    this.documentSearchService.searchCriteria = {};
    this.documentSearchService.searchCriteria = this.documentSearchData;
    // Convert to AppliedFilters format and store as base filters
    this.baseFilters = this.convertToAppliedFilters();
    // Ensure panelHubConfig has correct filter/sort configs for the current view
    this.updatePanelHubConfigForCurrentView();
    // Reset panel configuration (this will restore baseFilters)
    this.resetPanelConfiguration();
    // Mark that user has initiated a search
    this.hasUserSearched = true;
    // Show spinner for main search
    this.spinnerOn = true;
    this.refreshPanelHubData();

    return of(this.pagedData.totalRecords);
  };

  setButtonOnSearchRecordCount(searchRecordsCount: number) {
    this.shouldAddLinkItemsButtonDisplayed.emit(searchRecordsCount > 0);
    this.shouldAddTrainingItemAsDocumentButtonDisplayed.emit(searchRecordsCount > 0);
  }

  resetDocumentSearchData() {
    this.documentSearchData.phases = undefined;
    this.documentSearchData.categories = undefined;
    this.documentSearchData.creationDates = undefined;
    this.documentSearchData.documentTypes = undefined;
    this.documentSearchData.localTypes = undefined;
    this.documentSearchData.localCategories = undefined;
    this.documentSearchData.responsibleSubBUs = undefined;
    this.documentSearchData.eQMSScopes = undefined;
    this.documentSearchData.effectiveDates = undefined;
    this.documentSearchData.periodicReviewDates = undefined;
    this.documentSearchData.searchText = undefined;
    this.documentSearchData.tags = undefined;
    this.documentSearchData.users = undefined;
  }

  linkedItemsSelectedData(event: any) {
    this.displayDataCollected = event;
    this.emitSelectedData.emit(this.displayDataCollected);
  }

  getLinkedItemsSelection() {
    this.childDocPanel?.clearSelection();
  }

  populateMasterFilterData(scopeList: IEQMSScopeLookUpDetails[], subBUData: any, usersData: any, assignmentGroups: any[], trainingItemGroups: any[]): void {
    const baseUserNames = usersData.map((user: { name: string }) => user.name);

    const assignedAdminGroups = assignmentGroups.filter((group: any) =>
      group.assignment === DocumentLibraryConstants.Assignment_types.AssignedAdmins);
    const assignedDocControlGroups = assignmentGroups.filter((group: any) =>
      group.assignment === DocumentLibraryConstants.Assignment_types.AssignedDocControl);
    const assignedQAGroups = assignmentGroups.filter((group: any) =>
      group.assignment === DocumentLibraryConstants.Assignment_types.AssignedQA);

    const assignedAdminsSet = new Set(baseUserNames);
    assignedAdminGroups.forEach((group: any) => {
      if (group.name) {
        assignedAdminsSet.add(group.name);
      }
    });
    const assignedAdminsList = Array.from(assignedAdminsSet)
      .sort((a, b) => (a as string).localeCompare(b as string))
      .map((name) => ({ name: name as string, value: name as string }));

    const assignedDocControlsSet = new Set(baseUserNames);
    assignedDocControlGroups.forEach((group: any) => {
      if (group.name) {
        assignedDocControlsSet.add(group.name);
      }
    });
    const assignedDocControlsList = Array.from(assignedDocControlsSet)
      .sort((a, b) => (a as string).localeCompare(b as string))
      .map((name) => ({ name: name as string, value: name as string }));

    const assignedQAsSet = new Set(baseUserNames);
    assignedQAGroups.forEach((group: any) => {
      if (group.name) {
        assignedQAsSet.add(group.name);
      }
    });
    const assignedQAsList = Array.from(assignedQAsSet)
      .sort((a, b) => (a as string).localeCompare(b as string))
      .map((name) => ({ name: name as string, value: name as string }));

    const trainingItemGroupsList = trainingItemGroups
      .filter((tig: any) => tig.name)
      .map((tig: any) => ({ name: tig.name, value: tig.name }))
      .sort((a: any, b: any) => a.name.localeCompare(b.name));

    this.masterFilterData = {
      phases: this.documentMasterData.phases.map((phase: { name: string; value: any }) => ({
        name: phase.name,
        value: phase.value?.toString() ?? phase.name
      })),
      documentTypes: this.documentMasterData.documentTypes.map((type: { name: string }) => ({
        name: type.name,
        value: type.name
      })),
      categories: this.documentMasterData.categories.map((category: { name: string }) => ({
        name: category.name,
        value: category.name
      })),
      localCategories: this.documentMasterData.localCategories.map((localCategory: { name: string }) => ({
        name: localCategory.name,
        value: localCategory.name
      })),
      localTypes: this.documentMasterData.localTypes.map((localType: { name: string; value: number }) => ({
        name: localType.name,
        value: localType.value
      })),
      subBUList: subBUData.map((subBU: { name: string }) => ({
        name: subBU.name,
        value: subBU.name
      })),
      eqmsScopeList: scopeList.map((scope: IEQMSScopeLookUpDetails) => ({
        name: scope.eQMSScopeName,
        value: scope.eQMSScopeId.toString()
      })),
      curriculumsList: scopeList.map((scope: IEQMSScopeLookUpDetails) => ({
        name: scope.eQMSScopeName,
        value: scope.eQMSScopeName
      })),
      assignedAdminsList: assignedAdminsList,
      assignedDocControlsList: assignedDocControlsList,
      assignedQAsList: assignedQAsList,
      trainingItemGroupsList: trainingItemGroupsList,
      usersList: usersData.map((user: { name: string }) => ({
        name: user.name,
        value: user.name
      }))
    };
  }

  loadDocumentSearchFilterOptions() {
    this.documentMasterData.phases.forEach((phase: any) => {
      phase.value = phase.value.toString();
    });
    this.phaseList = this.documentMasterData.phases;
    this.searchControl.push(
      {
        controlType: ControlType.List,
        label: 'Type',
        fieldName: 'type',
        options: this.documentMasterData.documentTypes,
        multiSelect: true,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 1,
      },
      {
        controlType: ControlType.List,
        label: 'Local Type',
        fieldName: 'localType',
        options: this.documentMasterData.localTypes,
        multiSelect: true,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 2,
      },
      {
        controlType: ControlType.List,
        label: 'Category',
        fieldName: 'category',
        multiSelect: true,
        options: this.documentMasterData.categories,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 3,
      },
      {
        controlType: ControlType.List,
        label: 'Local Category',
        fieldName: 'localCategory',
        multiSelect: true,
        options: this.documentMasterData.localCategories,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 4,
      },
      {
        controlType: ControlType.List,
        label: 'Phase',
        fieldName: 'phase',
        multiSelect: true,
        options: this.phaseList,
        value: [PhaseValueConstants.Effective.toString()],
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 7,
      },
      {
        controlType: ControlType.List,
        label: 'Tag(s)',
        fieldName: 'tags',
        multiSelect: true,
        options: this.documentMasterData.tags,
        value: undefined,
        labelField: 'name',
        valueField: 'value',
        showFilter: true,
        order: 10,
      }
    );
  }

  private populateEQMSScopeList = (locationsData: IEQMSScopeLookUpDetails[]): void => {
    for (let dataItem of locationsData) {
      this.scopeList.push({
        value: dataItem.eQMSScopeId,
        name: dataItem.eQMSScopeName,
      });
    }

    this.searchControl.push({
      controlType: ControlType.List,
      label: 'eQMS Scope',
      fieldName: 'eQMSScope',
      multiSelect: true,
      options: this.scopeList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      order: 6,
      showFilter: true
    });
  }

  private populatesubBuList = (subBuData: any): void => {
    this.sbuList = subBuData;
    this.searchControl.push({
      controlType: ControlType.List,
      label: 'Responsible Sub-BU',
      fieldName: 'responsibleSubBU',
      multiSelect: true,
      options: this.sbuList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 5,
    });
  }

  private populateUsersList = (usersData: any): void => {
    this.userList = usersData.map((dataItem: any) => ({
      value: `${dataItem.name}`,
      name: `${dataItem.name}`,
    }));
    this.searchControl.push({
      controlType: ControlType.List,
      label: 'User',
      fieldName: 'user',
      multiSelect: true,
      options: this.userList,
      value: undefined,
      labelField: 'name',
      valueField: 'value',
      showFilter: true,
      order: 12,
    });
  }

  convertDateFormat(values: any) {
    if (values !== null && values !== undefined && values.length == 2)
      return values;
    else if (values !== null && values !== undefined && typeof (values) === "string") {
      let effectiveDateSelected: Date = new Date(values);
      let effectiveDate: Date[] = [];
      effectiveDate.push(effectiveDateSelected);
      return effectiveDate;
    }
  }
  
  downloadSourceFile(documentNumber: string, version: string, phase: string, printLock: boolean = false): void {
    const phaseNum = Number(phase);
    
    // Determine if we need to show info message for formatted file generation
    const formattedFileGenerationPhase = 
      phaseNum === PhaseValueConstants.InReview || 
      phaseNum === PhaseValueConstants.Approved ||
      phaseNum === PhaseValueConstants.Effective ||
      phaseNum === PhaseValueConstants.ClientSignature;
    
    // Show info message if file is being generated
    if (formattedFileGenerationPhase) {
      setTimeout(() => {
        this.messageService.add({
          severity: DocumentLibraryConstants.Severity_Info,
          summary: DocumentLibraryConstants.Document_File_Availability_Status_Information
        });
      }, 50);
    }

    // Determine which file to download based on phase
    if (phaseNum === PhaseValueConstants.Collaboration || 
        phaseNum === PhaseValueConstants.QaReview || 
        phaseNum === PhaseValueConstants.Formatting) {
      // Download source file for early phases
      this.getAndDownloadSourceFile(documentNumber, version, formattedFileGenerationPhase, printLock);
    } else if (phaseNum !== PhaseValueConstants.Cancelled) {
      // Download formatted file for later phases
      this.getAndDownloadFormattedFile(documentNumber, version, formattedFileGenerationPhase, printLock);
    }
  }

  private getAndDownloadSourceFile(
    documentNumber: string, 
    version: string, 
    showInfoMessage: boolean,
    printLock: boolean
  ): void {
    this.documentService.getDocumentSourceFile(documentNumber, version).subscribe({
      next: (documentSourceFile) => {
        this.downloadFile(documentSourceFile.fileId, documentSourceFile.name, showInfoMessage, printLock, '', documentNumber, version);
      },
      error: (error) => {
        if (showInfoMessage) {
          this.messageService.clear();
        }
        if (error.status === 401) {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          });
        } else {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.DocumentSourceFile_Creation_Failed,
            sticky: true
          });
        }
      }
    });
  }


  private getAndDownloadFormattedFile(
    documentNumber: string, 
    version: string, 
    showInfoMessage: boolean,
    printLock: boolean
  ): void {
    this.documentService.getDocumentDetailsForDocumentFormattedFile(documentNumber, version).subscribe({
      next: (documentFormattedFile) => {
        this.downloadFile(
          documentFormattedFile.fileId, 
          documentFormattedFile.name, 
          showInfoMessage, 
          printLock,
          documentFormattedFile.fileType,
          documentNumber,
          version
        );
      },
      error: (error) => {
        if (showInfoMessage) {
          this.messageService.clear();
        }
        if (error.status === 401) {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: `${error.error}`,
          });
        } else {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.File_Generation_Failed,
            sticky: true
          });
        }
      }
    });
  }

  private downloadFile(
    fileId: string, 
    fileName: string, 
    showInfoMessage: boolean, 
    printLock: boolean,
    fileType: string,
    documentNumber: string,
    version: string
  ): void {
    this.documentService.downloadFile(fileId).subscribe({
      next: (response) => {
        if (showInfoMessage) {
          this.messageService.clear();
        }
        
        // If it's a PDF and printLock is enabled, show preview instead of downloading
        if ((fileType === '.pdf' || fileType === '.PDF') && printLock) {
          this.readOnlyFileUrl = response.fileUri;
          this.openPdfPreviewModal = true;
        } else {
          this.performFileDownload(response.fileUri, fileName);
        }
        
        // Add audit for document read activity
        this.addAuditForDocumentReadActivity(documentNumber, version);
      },
      error: () => {
        if (showInfoMessage) {
          this.messageService.clear();
        }
        if (fileId != undefined && fileId != null) {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_UnableToDownload,
            sticky: true
          });
        } else {
          this.messageService.add({
            severity: DocumentLibraryConstants.Severity_Err,
            summary: DocumentLibraryConstants.Document_File_NotAvailableToDownload,
            sticky: true
          });
        }
      }
    });
  }


  private performFileDownload(fileUrl: string, fileName: string): void {
    const downloadLink = document.createElement('a');
    document.body.appendChild(downloadLink);
    downloadLink.setAttribute('style', 'display: none');
    downloadLink.href = fileUrl;
    downloadLink.download = fileName;
    downloadLink.target = '_blank';
    downloadLink.click();
    downloadLink.remove();
  }

  private addAuditForDocumentReadActivity = (number: string, version: string) => {
    let documentReadAuditDto: DocumentReadAudit = {
      documentNumber: number,
      documentVersion: Number(version),
      attributeName: "Document Source File"
    };
    this.documentService.addAuditForDocumentRead(documentReadAuditDto).subscribe();
  }


  showPdfPreviewModal(isModalShow: boolean): void {
    this.openPdfPreviewModal = isModalShow;
  }
}
